import { gql } from 'graphql-request';

export const UPDATE_USER_DETAILS_QUERY = gql`
  mutation ($firstName: String, $lastName: String) {
    updateUserDetails(
      updateUserDetailsInput: { firstName: $firstName, lastName: $lastName }
    ) {
      status
      code
    }
  }
`;
